<template>
  <icon-base
    :title="title"
    :name="name"
    :viewbox="viewBox">
    



<g>
	<path d="M12,20.251c-0.62,0-1.125-0.505-1.125-1.125s0.505-1.125,1.125-1.125c0.62,0,1.125,0.505,1.125,1.125
		S12.62,20.251,12,20.251z"/>
	<path d="M12,16.501c-0.414,0-0.75-0.336-0.75-0.75v-7.5c0-0.414,0.336-0.75,0.75-0.75c0.413,0,0.75,0.336,0.75,0.75v7.5
		C12.75,16.164,12.413,16.501,12,16.501z"/>
	<path d="M2.272,24.001c-0.347,0-0.693-0.081-1.003-0.233c-0.543-0.267-0.951-0.731-1.147-1.305s-0.157-1.191,0.111-1.734
		L9.705,1.43c0.248-0.505,0.663-0.919,1.167-1.167c0.354-0.174,0.732-0.262,1.124-0.262c0.984,0,1.865,0.547,2.298,1.429
		l9.473,19.298C23.919,21.038,24,21.384,24,21.731c0,0.607-0.237,1.178-0.667,1.606c-0.428,0.428-0.998,0.664-1.604,0.664H2.272z
		 M11.997,1.501c-0.161,0-0.318,0.036-0.463,0.108c-0.208,0.102-0.38,0.274-0.482,0.482L1.579,21.39
		c-0.188,0.382-0.03,0.845,0.352,1.032c0.105,0.052,0.222,0.079,0.339,0.079h19.458c0.207,0,0.4-0.08,0.546-0.225
		c0.146-0.146,0.226-0.339,0.227-0.545c0-0.118-0.027-0.235-0.079-0.34L12.947,2.091C12.771,1.733,12.399,1.501,11.997,1.501z"/>
</g>


  </icon-base>
</template>

<script>
import IconBase from '../IconBase';

export default {
  components: {
    IconBase,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: 'alert-triangle',
    },
    name: {
      type: String,
      required: false,
      default: 'AlertTriangle',
    },
    viewBox: {
      type: String,
      required: false,
      default: '0 0 24 24',
    },
  },
};
</script>

<style scoped>
  
</style>